const Theme = {
  'logo': 'https://thechurchco-production.s3.amazonaws.com/uploads/2016/02/cropped-logo-icon-grey-2-180x180.png',
};

export default Theme;



// WEBPACK FOOTER //
// ./src/config/Theme.js